import { useMemo } from 'react';
import { usePermission } from './usePermission';
import { INVENTORY_PERMISSIONS } from '../constants/permissions.constants';

/**
 * KPI visibility for Gestión en Sucursal (granular flags under inventory-branch menu).
 */
export const useInventoryBranchKPIPermissions = () => {
  const canKpiTotalProducts = usePermission(INVENTORY_PERMISSIONS.BRANCH.KPI_TOTAL_PRODUCTS);
  const canKpiTotalSaleValue = usePermission(INVENTORY_PERMISSIONS.BRANCH.KPI_TOTAL_SALE_VALUE);
  const canKpiTotalCostValue = usePermission(INVENTORY_PERMISSIONS.BRANCH.KPI_TOTAL_COST_VALUE);
  const canKpiBajas = usePermission(INVENTORY_PERMISSIONS.BRANCH.KPI_BAJAS);

  return useMemo(
    () => ({
      canKpiTotalProducts,
      canKpiTotalSaleValue,
      canKpiTotalCostValue,
      /** Gestión en sucursal no define KPIs de ubicación (almacén/tránsito); alineado con InventoryStats union. */
      canKpiUnassigned: false,
      canKpiAssigned: false,
      canKpiInTransit: false,
      canKpiBajas,
    }),
    [canKpiTotalProducts, canKpiTotalSaleValue, canKpiTotalCostValue, canKpiBajas],
  );
};
